import type { QueryClient } from '@tanstack/react-query';
import { runInvalidationForMutation } from '../../query/runInvalidation';

/**
 * Call after subscription checkout or payment WebView success.
 * Only invalidates caches when data-layer invalidation mode is `replacement`.
 */
export async function invalidateOnCheckoutSuccess(
  query_client: QueryClient,
  customer_id: number,
): Promise<void> {
  await runInvalidationForMutation(query_client, {
    rule_id: 'checkout.complete',
    customer_id,
  });
}
